import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var SuccessDialog = /*#__PURE__*/React.lazy(function () {
  return import("@dp/web").then(function (module) {
    return {
      "default": module.SuccessDialog
    };
  });
});
var ErrorDialog = /*#__PURE__*/React.lazy(function () {
  return import("@dp/web").then(function (module) {
    return {
      "default": module.ErrorDialog
    };
  });
});
var Loading = /*#__PURE__*/React.lazy(function () {
  return import("@dp/web").then(function (module) {
    return {
      "default": module.Loading
    };
  });
});
var LoginPopup = /*#__PURE__*/React.lazy(function () {
  return import("@dp/web").then(function (module) {
    return {
      "default": module.LoginPopup
    };
  });
});

var DefaultLayout = function DefaultLayout(props) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [props.children, /*#__PURE__*/_jsx(SuccessDialog, {}), /*#__PURE__*/_jsx(ErrorDialog, {}), /*#__PURE__*/_jsx(Loading, {}), /*#__PURE__*/_jsx(React.Suspense, {
      fallback: /*#__PURE__*/_jsx(_Fragment, {}),
      children: /*#__PURE__*/_jsx(LoginPopup, {})
    })]
  });
};

export default DefaultLayout;